import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectBoxServiceService } from '../service/select-box-service.service';
@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss'],
})
export class SelectBoxComponent implements OnInit {

  @Input() value: string;
  @Input() addCustomClass: string;
  @Input() addBackground: string;
  @Input() optionsContainerHeight: string;
  expandir_contraer: boolean = false
  @Input() addFilterIcon: boolean = false;
  @Input() addAlertIcon: boolean = false;
  @Output() selectClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(private service: SelectBoxServiceService) { }

  ngOnInit() {
    this.service.open_and_close.subscribe(res => this.expandir_contraer = res)
  }

  abrirCerrar() {
    this.expandir_contraer = !this.expandir_contraer;
    this.selectClick.emit(this.expandir_contraer);
  }

  handleClickedOutside(){
    this.expandir_contraer = false;
    // this.selectClick.emit(this.expandir_contraer);
  }

}
